export default __webpack_public_path__ + "static/media/xero.663edb61.png";